import normalizeReportFinanceCommissionTmHotelReconciliationHotelOnly from '/src/data/response/normalizeReportFinanceCommissionTmHotelReconciliationHotelOnly.js';
import { storeConstants } from '@utils/constants';
import factory from '@helpers/storeFactories/factory';

import { apiServiceTMHotelReconciliationHotelOnly } from '@api';

const STORE_NAME = 'TmHotelReconciliationHotelOnly';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServiceTMHotelReconciliationHotelOnly.tmHotelReconciliationHotelOnly.get,
    },
    {
        actions: {
            delete: true,
            select: true,
        },
        actionsOptions: {
            get: {
                defaultOptions: {
                    refresh: false,
                    offset: 0,
                    limit: 99,
                },
                controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
            },
        },
        normalizeItemFn: normalizeReportFinanceCommissionTmHotelReconciliationHotelOnly,
    },
    {
        getters: {
            isMultiSelected: (state, getters) => () => {
                return getters.getAllSelected().length > 1;
            },
        },
    }
);

export default store;
